module.exports = __webpack_public_path__ + "static/media/bg_drawer.5927ebe8.svg";